/* eslint-disable */
import React, { useState } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useStyles } from "../../constants/styles";
import signOut from "../../services/signOut";
import { setOpenSideMenu } from "../../store/ducks/sideMenu/actions";
import { UserState } from "../../interfaces";
import ItemListSideMenu from "../itemListSideMenu";
import CollapseSideMenu from "../collapseSideMenu";
import AppBarTop from "../appBar";
import { Container, Img, SwipeableDrawer, List, Collapse, Nav } from "./styles";
import { PolepostionProps, scheduleProps, ScheduleReservation } from "./routes";
import Icons from "../../constants/icons";
import { ImTable } from "react-icons/im";

export default function PersistentDrawerLeft() {
  const classes = useStyles();
  const dispatch = useDispatch();
  // @ts-ignore
  const { open } = useSelector((state) => state.sideMenuReducer);
  // @ts-ignore
  const [openRulesReserva, setOpenRulesReverva] = useState<boolean>(false);
  const [openPoliposition, setOpenPoliposition] = useState<boolean>(false);
  const [openScheduleReservation, setScheduleReservation] =
    useState<boolean>(false);
  const { permissoes } = useSelector<RootStateOrAny, UserState>(
    (state) => state.user
  );

  const handleDrawerOpen = () => {
    dispatch(setOpenSideMenu(true));
  };

  const handleDrawerClose = () => {
    dispatch(setOpenSideMenu(false));
  };

  const exitToApp = () => {
    signOut();
  };

  return (
    <Container>
      <AppBarTop setOpen={open ? handleDrawerClose : handleDrawerOpen} />
      <SwipeableDrawer
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
        open={open}
        onClose={handleDrawerClose}
        onOpen={handleDrawerOpen}
      >
        <Nav>
          <List>
            {permissoes?.includes("admin_pg_gestao_usuarios") ? (
              <ItemListSideMenu
                name="Usuários"
                icon={<Img src={Icons.userIcon} />}
                route="/usuarios"
                onPress={() => handleDrawerClose()}
              />
            ) : null}
            <ItemListSideMenu
              name="Empreendimentos"
              icon={<Img src={Icons.enterpriseIcon} />}
              route="/empreendimentos"
              onPress={() => handleDrawerClose()}
            />
            {permissoes?.includes("admin_pg_gestao_locais") ? (
              <>
                <ItemListSideMenu
                  name="Locais"
                  icon={<Img src={Icons.placeIco} />}
                  route="/listar-locais"
                  onPress={() => handleDrawerClose()}
                />
              </>
            ) : null}
            <ItemListSideMenu
              name="Horário de reserva"
              icon={<Img src={Icons.reservaIcon} />}
              onPress={() => {
                setOpenRulesReverva(false);
                setOpenPoliposition(false);
                setScheduleReservation(!openScheduleReservation);
              }}
            />
            <Collapse in={openScheduleReservation} timeout="auto" unmountOnExit>
              {ScheduleReservation.map((item) => (
                <CollapseSideMenu
                  path={item.path}
                  name={item.labe}
                  icon={item.icon}
                  action={() => {
                    setScheduleReservation(!openScheduleReservation);
                    handleDrawerClose();
                  }}
                />
              ))}
            </Collapse>
            <ItemListSideMenu
              name="Gestão de reserva"
              icon={<Img src={Icons.gestaoIcon} />}
              isArrow
              arrow={<Img height={16} src={Icons.arrowIcon} />}
              onPress={() => {
                setOpenRulesReverva(!openRulesReserva);
                setOpenPoliposition(false);
                setScheduleReservation(false);
              }}
            />
            <Collapse in={openRulesReserva} timeout="auto" unmountOnExit>
              {scheduleProps.map((item) => (
                <CollapseSideMenu
                  path={item.path}
                  name={item.labe}
                  icon={item.icon}
                  action={() => {
                    setOpenRulesReverva(!openRulesReserva);
                    handleDrawerClose();
                  }}
                />
              ))}
            </Collapse>
            <ItemListSideMenu
              name="Pole position"
              icon={<Img src={Icons.poleIcon} />}
              isArrow={false}
              arrow={<Img src={Icons.arrowIcon} />}
              route="/polipositions"
              onPress={() => {
                handleDrawerClose();
              }}
            />
            <ItemListSideMenu
              name="Log de usuários"
              icon={<ImTable color="#333333" />}
              isArrow={false}
              arrow={<Img src={Icons.arrowIcon} />}
              route="/log-usuarios"
              onPress={() => {
                handleDrawerClose();
              }}
            />
            <Collapse in={openPoliposition} timeout="auto" unmountOnExit>
              {PolepostionProps.map((item) => (
                <CollapseSideMenu
                  path={item.path}
                  name={item.labe}
                  icon={item.icon}
                  action={() => {
                    setOpenPoliposition(!openPoliposition);
                    handleDrawerClose();
                  }}
                />
              ))}
            </Collapse>
          </List>
          <ItemListSideMenu
            name="Sair"
            icon={<Img src={Icons.exitIcon} />}
            onPress={() => {
              exitToApp();
            }}
          />
        </Nav>
      </SwipeableDrawer>
    </Container>
  );
}
